export const billetStatus = [
	{
		code: "H",
		name: "on hand",
		backgroundColor: "#C5E0B3",
		hoverColor: "#e9f3e2ff",
	},
	{
		code: "C",
		name: "to be cast SWVA",
		backgroundColor: "#eded67ff",
		hoverColor: "#f9f9b7ff",
	},
	{
		code: "O",
		name: "on order",
		backgroundColor: "#c3d3ee",
		hoverColor: "#f2f5fdff",
	},
	{
		code: "N",
		name: "need to order",
		backgroundColor: "#EDA5BF",
		hoverColor: "#f8e1eaff",
	},
];
